import { __rest, __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import { Card } from '@chakra-ui/react';
import React from 'react';

var BorderedCard = function (props) {
    var borderPosition = props.borderPosition, children = props.children, rest = __rest(props, ["borderPosition", "children"]);
    var borderStyle = {
        borderLeft: borderPosition === 'left' ? '4px solid' : 'none',
        borderRight: borderPosition === 'right' ? '4px solid' : 'none',
        borderTop: borderPosition === 'top' ? '4px solid' : 'none',
        borderBottom: borderPosition === 'bottom' ? '4px solid' : 'none',
    };
    return (React.createElement(Card, __assign({ border: "4px ".concat(borderPosition), borderRadius: "md", boxShadow: "md" }, borderStyle, rest), children));
};

export { BorderedCard as default };
//# sourceMappingURL=BorderedCard.js.map
